export default __webpack_public_path__ + "static/media/006-cheese.e14f0396.svg";